import { useEffect } from 'react';

/**
 * Body scroll lock hook for mobile-app feel.
 * When a modal is open the background must NOT scroll.
 * Preserves the current scroll position and restores it on close.
 */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;

    const scrollY = window.scrollY;
    const body = document.body;

    // Save original styles
    const originalOverflow = body.style.overflow;
    const originalPosition = body.style.position;
    const originalTop = body.style.top;
    const originalWidth = body.style.width;

    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    body.classList.add('qrm-no-scroll');

    return () => {
      body.style.overflow = originalOverflow;
      body.style.position = originalPosition;
      body.style.top = originalTop;
      body.style.width = originalWidth;
      body.classList.remove('qrm-no-scroll');
      window.scrollTo(0, scrollY);
    };
  }, [locked]);
}
